// CONSTANTS
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const GLOBAL_ERRORS = 'GLOBAL_ERRORS';
// TYPE
export const TYPE_LIST = 'LIST';
export const TYPE_ELEMENT = 'ELEMENT';

// MODULE
export const MN_ACTIVITIES = 'ACTIVITIES';
export const MN_CUSTOMERS = 'CUSTOMERS';
export const MN_GESTIFY_CREDENTIALS = 'GESTIFY-CREDENTIALS';
export const MN_JOBS = 'JOBS';
export const MN_ORDERS = 'ORDERS';
export const MN_ORDER_COUNTERS = 'ORDER-COUNTERS';
export const MN_RESOURCES = 'RESOURCES';
export const MN_RESOURCE_SKILLS = 'RESOURCE-SKILLS';
export const MN_SCHEDULED_VALUES = 'SCHEDULED-VALUES';
export const MN_SKILLS = 'SKILLS';
export const MN_SUPPLIERS = 'SUPPLIERS';
export const MN_TIMESHEET = 'TIMESHEETS';
export const MN_TIMESHEET_LOCK = 'TIMESHEET-LOCKS';
export const MN_TYPE_OF_PAYMENTS = 'TYPE-OF-PAYMENTS';
export const MN_USERS = 'USERS';

// ACTIONS
export const ACT_SET = 'SET';

// URL
export const API = '/api';
export const V1 = '/v1';
export const ME = '/me';
export const AUTH = '/auth';
export const LOGIN = '/login';
export const HOME = '/home';
export const STAFF = '/staff';
export const USERS_URL = '/users';
export const BASE_URL = `${process.env.VITE_BASE_URL}${API}${V1}`;

// DATE
export const DATE_FORMAT = {
  YYYY_MM_DD: 'YYYY-MM-DD',
  YYYY_MM_DD_HH_MM: 'YYYY-MM-DD HH:mm',
  YYYY_MM_DDTHH_MM: 'YYYY-MM-DDTHH:mm',
  YYYY: 'YYYY',
  DD_MM_YYYY: 'DD/MM/YYYY',
  DD_MM_YYYY_HH_MM: 'DD/MM/YYYY HH:mm',
  DD_MM_YYYY_HH_MM_SS: 'DD/MM/YYYY HH:mm:ss',
  DD_MM_YYYY__HH_MM: 'DD-MM-YYYY\xa0\xa0HH:mm:ss',
  DD_MM_YYYY_WITH_MINUS: 'DD-MM-YYYY',
  DD_MMMM_YYYY: 'DD MMMM YYYY',
  MMMM_YYYY: 'MMMM YYYY',
  HH_MM: 'HH:mm',
};

// API METHODS
export const GET = 'GET';
export const POST = 'POST';
export const PATCH = 'PATCH';
export const DELETE = 'DELETE';
export const MULTIPART = 'MULTIPART';

// REGEX
export const PHONE_REGEX = /^\+(?:[0-9] ?){6,14}[0-9]$/;
